import React from 'react';
// import 'react-date-range/dist/styles.css';
// import 'react-date-range/dist/theme/default.css';
// import DateRangePickerComponent from './DateRangeComponent';
import { DateRange } from './types';
import { XIcon } from 'assests/GmsIcons';

type DateRangePickerDialogProps = {
  isOpen?: boolean;
  onClose: () => void;
  onChange: (range: DateRange) => void;
}

const DateRangePickerDialog = ({ onClose, onChange } : DateRangePickerDialogProps) => {
  return (
    <div className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-20`}>
      <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-auto tw-h-auto`}>
        <div className={`tw-flex tw-justify-between tw-items-center tw-pe-3`}>
            <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-mx-3`}>Select a Date Range</h2>
            <span onClick={onClose}><XIcon/></span>
        </div>
        <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />  
        <div className={`tw-mx-3 tw-my-3 `}>
            {/* <DateRangePickerComponent onChange={onChange} /> */}
        </div>
      </div>
    </div>
  );
};

export default DateRangePickerDialog;





